export default __webpack_public_path__ + "static/media/CrossroadsMap.1d5afc06.jpg";